// extracted by mini-css-extract-plugin
export var label = "_l0-2";
export var slideContainer = "_l0-0";
export var slider = "_l0-1";